import mapboxgl from 'mapbox-gl';
import { logger } from '../../utils/logger';

// Declare global variables used from external scripts
declare const L: any;
declare const $: any;
declare const EASYMAP: any;
declare const leafletMap: any;

const log = logger('liveFiresHelpers');



export function decodeResponse(id:any) {
  // log.debug('id', id, typeof id)
  let target
  if (typeof id==='string') {
      target=id
  } else {
      target=id.value[0].id
  }

  const responseMap=[
      {
          key: 'Abandoned',
          value: 'c61cdf68-8439-404f-b5f0-f0f9c805527c'
      },
      {

          key: 'Being Monitored',
          value: '15181fa8-b803-47a8-8ca2-513aa2c6ccd2'
      },
      {

          key: 'Delayed Action',
          value: '2dae2a6e-a00a-490c-b6ee-55c46d972de6'
      },
      {

          key: 'Initial Attack',
          value: '3d43dbc2-8ffc-4dd9-a6b4-cd2b76dd463a'
      },
      {

          key: 'Limited Action',
          value: '65c9be78-4bd0-42a1-ac7f-f59fcc670df1'
      },
      {

          key: 'Sustained Action',
          value: '4629c9a9-6ca8-4268-8cdb-b7c7ff2ea363'
      }
  ]
  // const response = responseMap.find((item) => item.value === id.value)
  // log.debug('response', response)
  // return response.key

  const found = responseMap.find((item) => item.value===target);
  return found?.key;
}
const liveFiresClickHandler=function (f:any) {

  var tag
  if (f.properties) {
      const estimatedStartDateStr=f.properties.estimatedStartDateObj;
      const estimatedStartDate=new Date(f.properties.estimatedStartDateObj);
      let differenceInDays: number | string;
      if (!isNaN(estimatedStartDate.getTime())) {
          const currentDate=new Date();
          const differenceInMs=currentDate.getTime()-estimatedStartDate.getTime();
          differenceInDays=Math.floor(differenceInMs/(1000*60*60*24));
          //      log.debug(`The number of days since the estimated start date is ${differenceInDays} days.`);
      } else {
          //    log.debug("The estimated start date is not a valid date string.");
          differenceInDays='??'
      }
      //   var out =[];
      // for (var key in f.properties) {
      //     out.push(key+': '+f.properties[key])
      //   }
      log.debug("f.properties", f.properties);
      var out=[
          `year: ${f.properties['objective.yearRequested']}`,
          `fireid: ${f.properties.number}`,
          `size: ${f.properties.estimatedSize}`,
          `status: ${f.properties.wildfireStatus}`,
          `response: ${decodeResponse(f.properties.responseCategoryId)}`,
          `causedby: ${f.properties.cause}`,
          `startdate: ${f.properties.estimatedStartDateObj}`,
          `fireageday: ${differenceInDays}`,
          `longitudeDD: ${f.properties.longitudeDD}`,
          `latitudeDD: ${f.properties.latitudeDD}`

      ]



      if (typeof f.properties.number!='undefined') {

          // Sample date string
          const discoveryDateStr=f.properties.discoveryDateObj;

          // Parse the discovery date
          const discoveryDate=new Date(discoveryDateStr);

          // Get the current date
          const currentDate=new Date();

          // Calculate the difference in milliseconds
          const differenceInMs=currentDate.getTime()-discoveryDate.getTime();

          // Convert the difference to hours
          const differenceInHours=differenceInMs/(1000*60*60);



          if (f.properties.wildfireStatus=='DECLARED_OUT') {
              tag='Out Wildfire '
          } else if (differenceInHours<=48) {
              tag='New Wildfire '
          } else {
              tag='Wildfire '
          }

      }
      return '<h3>'+tag+' '+f.properties.number+'</h3>'+out.join('<br />')


  }
}
const liveFiresHoverHandler=function (f:any) {

  var tag
  if (f.properties) {
      const estimatedStartDateStr=f.properties.estimatedStartDateObj;
      const estimatedStartDate=new Date(f.properties.estimatedStartDateObj);
      let differenceInDays: number | string;
      if (!isNaN(estimatedStartDate.getTime())) {
          const currentDate=new Date();
          const differenceInMs=currentDate.getTime()-estimatedStartDate.getTime();
          differenceInDays=Math.floor(differenceInMs/(1000*60*60*24));
          //      log.debug(`The number of days since the estimated start date is ${differenceInDays} days.`);
      } else {
          //    log.debug("The estimated start date is not a valid date string.");
          differenceInDays='??'
      }
      //   var out =[];
      // for (var key in f.properties) {
      //     out.push(key+': '+f.properties[key])
      //   }
      log.debug("f.properties", f.properties);
      var out=[
          `year: ${f.properties['objective.yearRequested']}`,
          `fireid: ${f.properties.number}`,
          `size: ${f.properties.estimatedSize}`,
          `status: ${f.properties.wildfireStatus}`,
          `response: ${decodeResponse(f.properties.responseCategoryId)}`,
          `causedby: ${f.properties.cause}`,
          `startdate: ${f.properties.estimatedStartDateObj}`,
          `fireageday: ${differenceInDays}`,
          `longitudeDD: ${f.properties.longitudeDD}`,
          `latitudeDD: ${f.properties.latitudeDD}`

      ]



      if (typeof f.properties.number!='undefined') {

          // Sample date string
          const discoveryDateStr=f.properties.discoveryDateObj;

          // Parse the discovery date
          const discoveryDate=new Date(discoveryDateStr);

          // Get the current date
          const currentDate=new Date();

          // Calculate the difference in milliseconds
          const differenceInMs=currentDate.getTime()-discoveryDate.getTime();

          // Convert the difference to hours
          const differenceInHours=differenceInMs/(1000*60*60);



          if (f.properties.wildfireStatus=='DECLARED_OUT') {
              tag='Out Wildfire '
          } else if (differenceInHours<=48) {
              tag='New Wildfire '
          } else {
              tag='Wildfire '
          }
          return tag+f.properties.number
      }

  }
}
const liveFiresPTLHandler=function (f:any, latlng:any) {
  var enableModelling
  // Sample date string
  const discoveryDateStr=f.properties.discoveryDateObj;

  // Parse the discovery date
  const discoveryDate=new Date(discoveryDateStr);

  // Get the current date
  const currentDate=new Date();

  // Calculate the difference in milliseconds
  const differenceInMs=currentDate.getTime()-discoveryDate.getTime();

  // Convert the difference to hours
  const differenceInHours=differenceInMs/(1000*60*60);
  var iconSize
  if (f.properties.wildfireStatus=='DECLARED_OUT') {
      var color='#252525'
      //  enableModelling = false;
      iconSize=23
  } else {
      if (differenceInHours<=48) {
          // var color = '#ff000a'
          var color='#bd0109'

          //  enableModelling = true;
          iconSize=40

          // // Canada Day Easter Egg
          // var canadaIcon =    L.icon({
          //     iconUrl: 'icons/maple_leaf.svg',
          //     iconSize: [20, 20], // size of the icon
          //     iconAnchor: [10, 10], // point of the icon which will correspond to marker's location
          //     popupAnchor: [0, -10] // point from which the popup should open relative to the iconAnchor
          // });
          //
          // return L.marker(latlng, {
          //     icon: canadaIcon,
          //     contextmenu: enableModelling,
          //     contextmenuItems: [{
          //         text: 'Model this fire!',
          //         iconCls: 'fa fa-flask',
          //         callback: function(){alert('Launch a model')}
          //     }]
          // })
      } else {
          var color='#ffcc19'
          // enableModelling = true;
          iconSize=30
      }
  }

  var hoverFlame=L.icon.mapkey({
      icon: 'fire',
      size: iconSize,
      color: color,
      background: false,
      //additionalCSS: 'text-shadow: 2px 2px 8px rgba(127, 127, 127, 1);'
      additionalCSS: 'text-shadow: 2px 2px 6px rgba(0,0,0, .7);'
  })

  // Append to marker:
  return L.marker(latlng, {
      icon: hoverFlame,
      contextmenu: false,
      contextmenuInheritItems: false,
      contextmenuItems: [
          {
              text: 'Fire Layers OFF!',
              iconCls: 'fa fa-power-off',
              callback: function (e: any) {
                  //machineName = EASYMAP.layers.overlayPool[EASYMAP.layers.getIndexByMachineName('nwtFireSitRT')].machineName
                  //EASYMAP.layers.overlayPool[EASYMAP.layers.getIndexByMachineName('nwtFireSitRT')].setVisibility('off')
                  EASYMAP.plugins.switcher.setButtonState('nwtFireSitRT', false)
                  // EASYMAP.plugins.switcher.setButtonState(machineName, false);
              }
          },
          {
              text: 'View Fire File!',
              iconCls: 'fa fa-files-o',
              callback: function (evt: any) {
                  log.debug('debugging fire file contest callback')
                  log.debug('evt passed', evt)
                  var fireId=evt.relatedTarget.feature.properties.number
                  window.open(
                      'https://www.sparcsonline.com/tng/view-wildfire/'+fireId,
                      '_blank'
                  )
              }
          },
          {
              text: 'Send FireID to GPS/Tools!',
              iconCls: 'fa fa-share',
              callback: function (evt: any) {
                  var fireId=evt.relatedTarget.feature.properties.number
                  $('#fire_lookup_box').val(fireId)
                  $('#fire_lookup_box').trigger('keydown')
                  let foob=$('#upload_fire_lookup_box').val(fireId)
                  $('#upload_fire_lookup_box').trigger('keydown')
              }
          },
          {
              text: 'Fire File Upload',
              iconCls: 'fa fa-cloud-upload',
              callback: function (evt: any) {
                  var fireId=evt.relatedTarget.feature.properties.number
                  // EASYMAP.plugins.psaas.growthAssessment(fireId);
                  EASYMAP.plugins.fireFile.displayfireFile()
                  let foo=$('#upload_fire_lookup_box_label').show()
                  let bar=$('#upload_fire_lookup_box')
                      .val(fireId)
                      .show()
                  $('#upload_fire_lookup_box').trigger('keydown')
                  $('#fireFileUploaderButton').trigger('click')
              }
          }
      ]
  })
}



export const firesDataObject={
    name: "Live Fires",
    shortName: "LiveFires",
    mainIcon: "fa-solid fa-fire",
    source: {
        "Fires": '/gs-proxy/geoserver/intellifire/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=intellifire:firesit&outputFormat=application%2Fjson',

    }

}

export const firesProcessingObject={
    source: {
        root: "Fires",
        rootKey: "id",
    },
    // Custom function to style the map display
    mapDisplay: function (data: any) {
        // Explicitly check if we're using a Leaflet map
        if (leafletMap&&leafletMap instanceof L.Map) {
            log.debug("Using Leaflet map styling");

            return {
                pointToLayer: liveFiresPTLHandler
            };
        }
        // For Mapbox GL
        else if (window.mapboxgl) {
            log.debug("Using Mapbox GL styling");
            return {
                type: 'circle',
                paint: {
                    'circle-radius': [
                        'interpolate', ['linear'], ['zoom'],
                        5, 4,
                        10, 8
                    ],
                    'circle-color': [
                        'case',
                        ['>', ['get', 'temp'], 25], '#FF0000', // Hot (red)
                        ['>', ['get', 'temp'], 15], '#FFA500', // Warm (orange)
                        ['>', ['get', 'temp'], 5], '#FFFF00',  // Mild (yellow)
                        ['>', ['get', 'temp'], -5], '#00FFFF', // Cool (cyan)
                        '#0000FF'                              // Cold (blue)
                    ],
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#FFFFFF'
                }
            };
        }

        // Fallback to default Leaflet styling if neither condition is met
        log.debug("Using fallback Leaflet styling");
        return {};
    },

    // Custom function to generate hover popup content
    hoverDisplay: liveFiresHoverHandler,

    // Custom function to generate click popup content
    clickDisplay: liveFiresClickHandler
};
export const firesOptionsObject={
    autoRefresh: true, // Automatically refresh data
    refreshInterval: 300000, // Refresh data every 5 minutes 
}